/* eslint-disable */

import { useState, useContext } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Context } from "../../../App";

import { RiPushpinFill } from "react-icons/ri";
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);
import { CiFolderOn } from "react-icons/ci";
import { PiNotePencil } from "react-icons/pi";


function IndividualFile({ item, handleFilesPinned, fetchQuillText }) {
  const navigate = useNavigate();
  const location = useLocation();

  const { fileIdContext, quillDocsContext, fileNameContext, showUsersContext,  } = useContext(Context);


  const [showUsers, setShowUsers] = showUsersContext;
  const [text, setQuillText] = quillDocsContext;
  const [fileId, setFileId] = fileIdContext;
  const [fileName, setFileName] = fileNameContext;

  const [pinnedHover, setPinnedHover] = useState(false);
  const currGroupId = location.pathname.split("/")[2] ? location.pathname.split("/")[2] : "";

  // const setCurrFolder = (e) => {
  //   console.log(e);
  // }

  return (
    <tr className={`hover:font-bold ${fileId === item.id ? "bg-lightPrimary" : "bg-white"}`}
      onClick={() => {
        // console.log(item);
        setFileId(item.id);
        setFileName(item.name);
        fetchQuillText(item.id);
        if (window.innerWidth < 750) setShowUsers(false);
      }}
      onMouseEnter={() => setPinnedHover(true)}
      onMouseLeave={() => setPinnedHover(false)}
    >
      <td className="border-b border-gray-200 px-2 text-gray-800 py-1 text-xs">

        <div className="flex items-center">
          <div className="h-5 w-5 flex-shrink-0">
            <PiNotePencil className="w-full h-full text-gray-600" />
          </div>
          <div className="ml-2 flex flex-col">
            <p className="whitespace-no-wrap text-xs lg:text-sm w-[120px] truncate">{item.name}</p>
            <p className="text-gray-500 text-xs">{dayjs(item.createdAt).format('lll')}</p>
          </div>
        </div>
      </td>
      <td className="border-b border-gray-200 pr-1 pl-1 text-xs">
        {/* <p className="whitespace-no-wrap">Defence</p> */}
        <div className=""
          onClick={(e) => {
            e.stopPropagation()
            handleFilesPinned(item.id)
          }}
        >
          <RiPushpinFill className={`w-4 h-4 ${item.isPinned ? "text-headPrimary" : pinnedHover ? "text-[#cfe2f4]" : "text-white"}`} />
        </div>

      </td>

    </tr>
  )
}

export default IndividualFile